import React from 'react';

export default function Account() {
    return (
        <div>
            Account Page Placeholder
        </div>
    );
}